import React, { createContext, useContext } from 'react';

import PropTypes from 'prop-types';

import { useJobNotification, useUser } from 'hooks';

const JobNotificationContext = createContext(null);

export const useJobNotificationContext = () => {
  const context = useContext(JobNotificationContext);
  if (context === null) return null;
  return context;
};

function JobNotificationProvider({ children }) {
  const { isAuthenticated } = useUser();
  const value = useJobNotification({ enabled: isAuthenticated });

  return (
    <JobNotificationContext.Provider value={value}>{children}</JobNotificationContext.Provider>
  );
}

JobNotificationProvider.propTypes = {
  children: PropTypes.node,
};

export default JobNotificationProvider;
